module.exports = __webpack_public_path__ + "static/media/call-blue-icon.368958cc.svg";